import { Component,  Input, Output, EventEmitter } from '@angular/core';
import { PublicEventInfo } from 'globals/store/public.model';
import { Exhibitor } from 'globals/store/exhibitors.data';
import { EntityProfileComponent } from 'src/app/components/entities/program-entity-profile.component';

@Component({
    selector: 'exhibitor-profile',
    template: `
<entity-profile 
  [labelMap]="!joiEvent ? null : joiEvent.exhibitor_labels"
  [exhibitor]="exhibitor"
  [hideImages]="!exhibitor?.logoUrl || !!exhibitor.hideLogo"
  [name]="exhibitor.name"
  [hideLabels]="!joiEvent ? true : exhibitor.hideLabels"
  [labels]="!joiEvent ? null : exhibitor.labels"
  [social]="exhibitor.social"
  [description]="exhibitor.description"
  [logoUrl]="exhibitor.fullLogoUrl || exhibitor.logoUrl"
  [callToAction]="exhibitor.callToAction"
  [callToActionUrl]="exhibitor.callToActionUrl"
  [joiEvent]="joiEvent"
></entity-profile>
`,
    standalone: true,
    imports: [EntityProfileComponent]
})
export class ExhibitorProfileComponent {
  @Input() exhibitor: Exhibitor
  @Input() joiEvent: PublicEventInfo
}



